/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Reingest_Approval_DescriptionInputs */

const es_components_reingest_approval_description = /** @type {(inputs: Components_Reingest_Approval_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El asistente quiere re-ingestar este archivo`)
};

const en_components_reingest_approval_description = /** @type {(inputs: Components_Reingest_Approval_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant wants to re-ingest this file`)
};

/**
* | output |
* | --- |
* | "The assistant wants to re-ingest this file" |
*
* @param {Components_Reingest_Approval_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_reingest_approval_description = /** @type {((inputs?: Components_Reingest_Approval_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Reingest_Approval_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_reingest_approval_description(inputs)
	return en_components_reingest_approval_description(inputs)
});
export { components_reingest_approval_description as "components.reingest_approval.description" }